import { render, staticRenderFns } from "./SpinnerWheelWaiting.vue?vue&type=template&id=60c79494&scoped=true&"
import script from "./SpinnerWheelWaiting.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelWaiting.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelWaiting.vue?vue&type=style&index=0&id=60c79494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c79494",
  null
  
)

export default component.exports